<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-04 09:36:33
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 14:39:58
 * @Description: 鲸鱼优选 - 标的列表
 -->

<template>
  <div class="project-list-wrapper">
    <Banner />
    <Jinyu></Jinyu>
    <number-one></number-one>
  </div>
</template>
<script>
import Banner from './components/banner';
import Jinyu from './components/jingyu';
import NumberOne from './components/number-one';
export default {
  name: 'project-list',
  components: {
    Jinyu,
    NumberOne,
    Banner
  }
};
</script>
